export default __webpack_public_path__ + "static/media/property_1_13.e96bfe7c.webp";